import React from 'react'
import KPICards from './KPICards'
import ChartCards from './ChartCards'
import QuickLinksCards from './QuickLinksCards'
import PnlGraphCard from './PnlGraphCard'
import ManualAlgoPnlCards from './ManualAlgoPnlCards'
import DiscoverCard from './DiscoverCard'
import PreferredBrokersCard from './PreferredBrokersCard'
import SocialLinksCard from './SocialLinksCard'
import './Dashboard.css'

const Home = () => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-wrapper">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Welcome to <span className="quik">Quik</span><span className="trade">Trade</span> By FNOTrader.com</h1>
          <p className="dashboard-subtitle">Your comprehensive trading dashboard</p>
        </div>

        
        <div className="dashboard-main-content">
          <div className="left-column">
            <QuickLinksCards />
            <ManualAlgoPnlCards />
              <PreferredBrokersCard />
          </div>
          <div className="right-column">
            <PnlGraphCard />
            <DiscoverCard />
            <SocialLinksCard />
          </div>
        </div>
        
        {/* <KPICards />
        <ChartCards /> */}
      </div>
    </div>
  )
}

export default Home